import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import './Facilities.scss';
import { PORT_FACILITIES } from 'constants/ports';

const FacilitiesView = ({ values }) => (
    <div className='facilities-block'>
        <div className='facilities-grid'>
            {PORT_FACILITIES.map(({ name, label }) => (
                <div key={name}>
                    <Checkbox
                        checked={values[name] || false}
                        label={label}
                        disabled
                    />
                </div>
            ))}
        </div>
    </div>
);

FacilitiesView.propTypes = {
    values: PropTypes.object.isRequired,
};

export default FacilitiesView;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Facilities/FacilitiesView.jsx